import type { SignalDetail } from '../../../types/signals-live';

export function toHumanCase(str: string): string {
  return str
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}

export function getTimeAgo(dateString: string | undefined): string {
  if (!dateString) return 'Unknown time';

  const now = new Date();
  const date = new Date(dateString);

  if (Number.isNaN(date.getTime())) {
    return 'Invalid date';
  }

  const diffMs = now.getTime() - date.getTime();
  const diffMinutes = Math.floor(diffMs / (1000 * 60));
  const diffHours = Math.floor(diffMinutes / 60);
  const diffDays = Math.floor(diffHours / 24);

  if (diffMinutes < 1) return 'Just now';
  if (diffMinutes < 60) return `${diffMinutes} minutes ago`;
  if (diffHours < 24) return `${diffHours} hours ago`;
  return `${diffDays} days ago`;
}

export function getReferrerSource(referrer?: string): string {
  if (referrer) {
    if (referrer.includes('/ombudsman')) return 'Case Guidance';
    if (referrer.includes('/vault')) return 'Conduct Records';
    if (referrer.includes('/today')) return 'Today';
    if (referrer.includes('/signals')) return 'Signals';
  }

  return 'Conduct Records';
}

export function getSignalTitle(signal: SignalDetail | null | undefined): string {
  return (
    signal?.summary ||
    signal?.summary_detailed?.substring(0, 50) ||
    signal?.verbatim?.substring(0, 50) ||
    'Signal'
  );
}

export function getSignalHeading(signal: SignalDetail): string {
  return (
    signal.summary ||
    (signal.summary_detailed ? `${signal.summary_detailed.substring(0, 80)}...` : undefined) ||
    (signal.verbatim ? `${signal.verbatim.substring(0, 50)}...` : undefined) ||
    'Untitled Signal'
  );
}

export function getSignalThreadMessages(signal: SignalDetail): any[] {
  const threadMessages =
    signal.thread_messages ||
    (Array.isArray(signal.thread_data) ? signal.thread_data : signal.thread_data?.messages) ||
    [];

  return Array.isArray(threadMessages) ? threadMessages : [];
}
